export default {"src":"/_next/static/media/enableToBuy.26041dc1.svg","height":129,"width":173};